import loadable from '@loadable/component';

export const ProductNotifyModal = loadable(() => import('components/productdetail/sharing/ProductNotifyModal'));
export const BrandStylesNotifyModal = loadable(() => import('components/productdetail/sharing/BrandStylesNotifyModal'));
export const OutOfStockModalWrapper = loadable(
  () => import(/* webpackChunkName: "OutOfStockModalWrapper", webpackPrefetch: 50 */ 'components/productdetail/OutOfStockModalWrapper')
);
export const RecommendedSizeFinderModal = loadable(() => import('components/productdetail/stylepicker/RecommendedSizeFinderModal'));
